<template>
  <v-btn icon @click="toggleMode">
    <v-icon dark v-if="currentMode === 'list'">mdi-view-grid</v-icon>
    <v-icon dark v-else="currentMode === 'cards'">mdi-view-list</v-icon>
  </v-btn>
</template>

<script>
const { mapMutations } = require('vuex');

export default {
  data: () => ({
    currentMode: 'list'
  }),
  props: {
    datatype: {
      type: String,
      required: true
    }
  },
  computed: {
    mode() {
      return (
        this.$store.state.AdminUserStore.listMode.find((item) => item.datatype === this.datatype)?.listMode ?? 'list'
      );
    }
  },
  methods: {
    ...mapMutations({
      setListMode: 'AdminUserStore/setListMode'
    }),
    toggleMode() {
      if (this.currentMode === 'list') {
        this.currentMode = 'cards';
      } else {
        this.currentMode = 'list';
      }
    }
  },
  watch: {
    currentMode: {
      handler(newMode) {
        this.setListMode({
          datatype: this.datatype,
          mode: newMode
        });
      }
    },
    datatype: {
      async handler() {
        this.currentMode = this.mode;
      },
      immediate: true
    }
  }
};
</script>
